import { useState } from 'react';
import { LOGO_URL } from '../config.ts';

export function Logo({ compact = false }: { compact?: boolean }) {
  const [failed, setFailed] = useState(false);
  return (
    <span className="brand" aria-label="My Genius Games">
      {failed ? (
        <span className="brand-mark-fallback" aria-hidden="true">MG</span>
      ) : (
        <img className="brand-mark" src={LOGO_URL} width="40" height="40" alt="" onError={() => setFailed(true)} />
      )}
      {!compact && <span className="brand-name">My Genius <span>Games</span></span>}
    </span>
  );
}
